import React, { useCallback, useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap"
import ReactBSAlert from "react-bootstrap-sweetalert"
import api from "services/api"
import SimpleHeader from "components/Headers/SimpleHeader.js"
import Loading from "components/Modals/Loading"

const formatDate = (value) => {
  if (!value) return ""
  return new Date(value).toLocaleString("pt-BR")
}

const UnansweredQuestionsPage = () => {
  const [questions, setQuestions] = useState([])
  const [loading, setLoading] = useState(false)
  const [removingIds, setRemovingIds] = useState([])
  const [search, setSearch] = useState("")
  const [questionToRemove, setQuestionToRemove] = useState(null)

  const fetchQuestions = useCallback(async () => {
    setLoading(true)
    try {
      const response = await api.get("smartchat-unanswered/all")
      setQuestions(response.data)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchQuestions()
  }, [fetchQuestions])

  const removeQuestion = async (id) => {
    setRemovingIds((prev) => [...prev, id])
    try {
      await api.delete("smartchat-unanswered/delete/" + id)
      setQuestions((prev) => prev.filter((q) => q._id !== id))
    } finally {
      setRemovingIds((prev) => prev.filter((removingId) => removingId !== id))
    }
  }

  const confirmRemoveQuestion = () => {
    const question = questionToRemove
    setQuestionToRemove(null)
    removeQuestion(question._id)
  }

  const normalizedSearch = search.trim().toLowerCase()

  const filteredQuestions = questions.filter((q) => {
    if (!normalizedSearch) return true
    return (q.question || "").toLowerCase().includes(normalizedSearch)
  })

  return (
    <>
      <SimpleHeader
        name="Perguntas sem resposta"
        items={[{ level: "nav", name: "SmartChat" }]}
      />
      <Container className="mt--6" fluid>
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col md="8">
                    <h5 className="h3 mb-0">Perguntas sem resposta no SmartChat</h5>
                    <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                      Perguntas que os usuários fizeram e o SmartChat não encontrou nos
                      materiais disponíveis. Use como referência para gravar novos vídeos.
                    </p>
                  </Col>
                  <Col md="4">
                    <Input
                      type="text"
                      placeholder="Pesquisar pergunta..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  {filteredQuestions.map((q) => (
                    <Col md="6" lg="4" key={q._id} className="mb-4">
                      <Card className="shadow-sm border mb-0">
                        <CardBody>
                          <p className="mb-2">{q.question}</p>
                          <p className="text-muted mb-2" style={{ fontSize: "0.75rem" }}>
                            {q.userFullName || q.userEmail || "Usuário não identificado"}
                            {" — "}
                            {formatDate(q.createdAt)}
                          </p>
                          <Button
                            size="sm"
                            color="secondary"
                            outline
                            disabled={removingIds.includes(q._id)}
                            onClick={() => setQuestionToRemove(q)}
                          >
                            Remover
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                  {!loading && filteredQuestions.length === 0 && (
                    <Col xs="12">
                      <p className="text-muted text-center mb-0 py-4">
                        Nenhuma pergunta sem resposta encontrada.
                      </p>
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Loading modalOpened={loading} />
      {questionToRemove && (
        <ReactBSAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={confirmRemoveQuestion}
          onCancel={() => setQuestionToRemove(null)}
          showCancel
          confirmBtnBsStyle="danger"
          confirmBtnText="Sim, remover"
          cancelBtnBsStyle="secondary"
          cancelBtnText="Cancelar"
          btnSize=""
        >
          Deseja mesmo remover esta pergunta da lista? Essa ação não pode ser
          desfeita.
        </ReactBSAlert>
      )}
    </>
  )
}

export default UnansweredQuestionsPage
